// Types
import * as Types from '../types'
import api from '../../../services/api'
import { callbackProps } from "../../../constants";
import { requestActionProps, requestGenerate } from "../../common";

const actionGetSubUserAvatars = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.SUB_USER_LIST),
  api: api.getSubUserAvatars,
  payload: { data: new URLSearchParams(payload) },
  callback,
});

export {
  actionGetSubUserAvatars
};